import { AbstractControl, ValidationErrors } from "@angular/forms";
import { DateTime } from "luxon";

export function yearDifferenceValidator(
    control: AbstractControl
): ValidationErrors | null {
    const parent = control.parent;
    if (!parent) {
        return null;
    }

    const fromDateValue = parent.get('fromDate')?.value;
    const toDateValue = parent.get('toDate')?.value;
    if (!fromDateValue || !toDateValue) {
        return null;
    }

    const fromDate = DateTime.fromISO(fromDateValue);
    const toDate = DateTime.fromISO(toDateValue);

    const differenceInYears = toDate.diff(fromDate, 'years').years;

    const differenceInDays =
        differenceInYears * 365 + Math.floor(differenceInYears / 4);

    if (differenceInDays > 365) {
        return { toDate };
    }

    return null;
}